import type { MoreAppError } from "../MoreAppError";

export const NON_RETRYABLE_STATUS_CODES = [400, 403, 404, 500, 502, 503, 504];

export const DEFAULT_MAX_RETRIES = 3;

export const doNotRetryOnUnrecoverableError = (failureCount: number, error: MoreAppError) => {
  if (NON_RETRYABLE_STATUS_CODES.includes(error?.status)) {
    return false;
  }
  return failureCount < DEFAULT_MAX_RETRIES;
};
